import script from "./FaturamentoPage.vue?vue&type=script&setup=true&lang=js"
export * from "./FaturamentoPage.vue?vue&type=script&setup=true&lang=js"

import "./FaturamentoPage.vue?vue&type=style&index=0&id=18388ac8&lang=css"

const __exports__ = script;

export default __exports__